import React from 'react';

import { IconEdit, Container, Field, Placeholder } from './styles';

interface Props {
  value: string;
  placeholder?: string;
  onClick: () => void;
}
const InputAddress = ({ value, placeholder, onClick }: Props) => (
  <Container onClick={onClick}>
    <Field>{!value && placeholder ? <Placeholder>{placeholder}</Placeholder> : value}</Field>
    <IconEdit />
  </Container>
);

export default InputAddress;
